const {BASE_URL} = require('./client');

const GET_HIRES = BASE_URL + '/api/hire/get';
module.exports = {
    GET_HIRES
}